<template>
    <section>
        <div class="main">
            <h2>{{ $t('homepage.videoRecordTitlePC') }}</h2>
            <p>{{ $t('homepage.videoRecordDes') }}</p>
            <ul>
                <li v-for="feature in featureList" :key="feature.title">
                    <div class="poster" :style="`background-image: url(${feature.poster});`"></div>
                    <div class="text">
                        <h3>{{ feature.title }}</h3>
                        <p>{{ feature.desc }}<tip v-if="feature.note"><div v-html="feature.note"></div></tip></p>
                    </div>
                </li>
            </ul>
        </div>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import RelayPoster from 'IMAGE/homepage/relay.webp';
import RichPoster from 'IMAGE/homepage/rich.webp';
import { config } from 'CONFIG';
import Tip from '@/basic/Tip.vue';
interface IFeature {
    title: string;
    desc: string;
    poster: string;
    note?: string;
}

export default Vue.extend({
    components: {
        Tip
    },
    computed: {
        featureList(): IFeature[] {

            return [
                {
                    poster: RelayPoster,
                    title: this.$tc( 'homepage.cloud.relay.title' ),
                    desc: this.$tc( 'homepage.cloud.relay.desc' )
                },
                {
                    poster: RichPoster,
                    title: this.$tc( 'homepage.cloud.rich.title' ),
                    desc: this.$tc( 'homepage.rich_notification_des' ),
                    note: this.$t( 'homepage.rich_notification_note', {
                        link: config.richNotificationSupport
                    }).toString()
                },
            ];

        }
    }
});
</script>

<style lang="less" scoped>
section{
    background-color: @bg_01;
    padding: 80px 0;
    .mobile({
        .mobileMaxWidth();
        padding: 32px 20px;
    });
    .main{
        max-width: 1200px;
        margin: 0 auto;
        text-align: center;
        h2{
            font-size: 42px;
            font-weight: 600;
            line-height: 60px;
            margin-bottom: 4px;
            .mobile({
                font-size: 28px;
                line-height: 36px;
            });
        }
        p{
            margin-top: 4px;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            .mobile({
                font-size: 14px;
            });
        }
        ul{
            display: flex;
            gap: 32px;
            margin-top: 55px;
            .mobile({
                flex-direction: column;
                gap: 24px;
            });
            li{
                flex: 1;
                background-color: @white;
                border-radius: @border-radius-level-3;
                .mobile({
                    background-color: @bg_02;
                });
                .poster{
                    height: 300px;
                    .mobile({
                        background-position: center;
                        border-top-left-radius: @border-radius-level-3;
                        border-top-right-radius: @border-radius-level-3;
                    })
                }
                .text{
                    padding: 24px;
                    h3{
                        font-size: 24px;
                        font-weight: 600;
                        line-height: 36px;
                        .mobile({
                            font-size: 20px;
                            line-height: 30px;
                        })
                    }
                    /deep/ .tip-icon{
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }
        }

    }
}
</style>
